import React, { useState } from "react";
import PropTypes from "prop-types";
import acceptIcon from "../assets/acceptIcon.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axios/axios";

const ScheduleInterview = ({ handleScheduleInterview, applicationId }) => {
  const navigate = useNavigate();
  const [acceptCandidate, setAcceptCandidate] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const org_id = localStorage.getItem("role_specific_id");
  const handleNoInterview = () => {
    setAcceptCandidate(!acceptCandidate);
  };

  const handleAcceptCandidate = async (id) => {
    try {
      const res = await axiosInstance.put(`/AcceptApplicationByOrg/${id}`, {
        org_id: org_id, // Ensure this is sent as a JSON object
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
    setAccepted(true);
  };

  const handleToApplication = () => {
    setAcceptCandidate(false);
    setAccepted(false);
    handleScheduleInterview();
    // navigate("/dashboard/applications");
  };

  const handleSetupInterview = (id) => {
    navigate(`/setUp-Interview?id=${id}`);
  };

  return (
    <>
      <div className="min-h-screen p-3 h-full xsm:fixed xsm:top-0 md:left-0 flex w-full items-center justify-center absolute rejection-card flex-col">
        {acceptCandidate ? (
          <div className="bg-white w-2/3 flex items-center justify-center p-6 rounded-3xl gap-4 shadow-lg">
            <div className="flex flex-col gap-3 items-center justify-center">
              <img src={acceptIcon} alt="" className="w-[48px]" />
              <span className="reject-text text-2xl font-semibold">
                Accept Candidate?
              </span>
              {accepted ? (
                <span className="text-center text-sm text-[#475467] max-w-[360px]">
                  You have successfully accepted this candidate{" "}
                </span>
              ) : (
                <span className="text-center text-sm text-[#475467] max-w-[360px]">
                  Please confirm the decision to accept the candidate and send a
                  formal acceptance letter.
                </span>
              )}
              {accepted ? (
                <div
                  className="font-bold btn btn-success w-full"
                  onClick={handleToApplication}
                >
                  Successful!
                </div>
              ) : (
                <section className="flex gap-4 my-4 flex-col w-full items-center justify-center">
                  <button
                    className="btn w-2/3 btn-outline-success py-2"
                    onClick={() => handleAcceptCandidate(applicationId)}
                  >
                    Yes
                  </button>
                  <button
                    className="btn w-2/3 btn-outline-danger py-2"
                    onClick={handleToApplication} // Correct state update for "No"
                  >
                    No
                  </button>
                </section>
              )}
            </div>
          </div>
        ) : (
          <div className="bg-white w-full flex flex-col items-center justify-center p-3 rounded-3xl gap-2">
            <div className="flex max-w-[360px] flex-col  gap-2 items-center justify-center">
              <span
                alt=""
                onClick={handleScheduleInterview}
                className="cursor-pointer btn-danger btn"
              >
                Cancel
              </span>
              <span className="reject-text">Schedule Interview?</span>
              <span className="text-center text-sm text-[#475467]">
                Would you like to arrange a virtual interview for this applicant
                via Google Meet?
              </span>
              <section className="flex gap-4 my-4 flex-col ">
                <button
                  className="btn btn-success  py-2"
                  onClick={() => handleSetupInterview(applicationId)}
                >
                  Yes, set up an interview
                </button>
                <button
                  className="btn btn-outline-success  py-2"
                  onClick={handleNoInterview}
                >
                  No, skip interview
                </button>
              </section>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

ScheduleInterview.propTypes = {
  handleScheduleInterview: PropTypes.func.isRequired, // Add PropTypes validation
  applicationId: PropTypes.number, // Add PropTypes validation
};

export default ScheduleInterview;
